import {
    ArrowRight,
    BarChart3,
    Book,
    Calendar,
    Camera,
    Check,
    CircleX,
    Download,
    Pause,
    ChevronDown,
    ChevronRight,
    Clock,
    Cog,
    Folder,
    ImageOff,
    UserRound,
    LayoutGrid,
    LogOut,
    Menu,
    Moon,
    Shield,
    Sun,
    User,
    Users,
    LayoutDashboard,
} from "lucide-react";

/*
 * A tiny name → lucide-react component map, so config files (nav.js, report
 * registries) can reference an icon by string without importing components.
 *
 * The markup used inline Lucide SVG paths; these are the same icons from the
 * package. Only add entries that are actually used — an unused import still
 * ships in the bundle.
 */
const ICONS = {
    shield: Shield,
    grid: LayoutGrid,
    camera: Camera,
    imageOff: ImageOff,
    check: Check,
    xCircle: CircleX,
    pause: Pause,
    userRound: UserRound,
    download: Download,
    arrowRight: ArrowRight,
    chart: BarChart3,
    team: Users,
    folder: Folder,
    squares: LayoutDashboard,
    user: User,
    calendar: Calendar,
    cog: Cog,
    book: Book,
    logout: LogOut,
    clock: Clock,
    menu: Menu,
    chevronRight: ChevronRight,
    chevronDown: ChevronDown,
    moon: Moon,
    sun: Sun,
};

export default function Icon({ name, className = "size-4.5 shrink-0", ...rest }) {
    const Cmp = ICONS[name];
    if (!Cmp) {
        // Loud in dev rather than a silently missing glyph.
        if (import.meta.env.DEV) console.warn(`<Icon name="${name}"> is not in the icon map`);
        return null;
    }
    return <Cmp className={className} strokeWidth={2} aria-hidden="true" {...rest} />;
}
